/** @format */
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, ViewEncapsulation } from '@angular/core';
import { CreditRange, CustomModuleAttainment, OtmId } from 'common-typescript/types';
import * as _ from 'lodash-es';
import { CustomModuleAttainmentStateObject, PlanStateObject } from '../../service/plan-state.service';
import { Action } from '../../study-boxes/study-action-box/study-action-box.component';
import { StudyBoxType } from '../../study-boxes/study-box/study-box.component';

@Component({
    selector: 'sis-plan-structure-custom-module-attainment-box',
    templateUrl: './plan-structure-custom-module-attainment-box.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class PlanStructureCustomModuleAttainmentBoxComponent implements OnChanges {
    @Input({ required: true }) customModuleAttainment: CustomModuleAttainment;
    @Input({ required: true }) planStateObject: PlanStateObject;
    @Input({ required: true }) headingLevel: number;
    @Input() selected?: boolean;
    @Input() action?: Action;
    @Output() actionChange? = new EventEmitter<OtmId>();

    customModuleAttainmentStateObject: CustomModuleAttainmentStateObject;
    visibleCredits: CreditRange | undefined;
    readonly studyBoxType = StudyBoxType.customModuleAttainment;

    ngOnChanges() {
        if (this.customModuleAttainment) {
            this.customModuleAttainmentStateObject = _.get(this.planStateObject.customModuleAttainments, this.customModuleAttainment.id);
            this.visibleCredits = { min: this.customModuleAttainment.credits, max: this.customModuleAttainment.credits };
        }
    }
}
